import React from 'react';

import { Fade } from 'react-reveal';
import CountUp from 'react-countup';
import Swiper from 'react-id-swiper';
import $ from 'jquery';

//Componentes
import { Select } from '../Select';
//Imagens
import { images } from '../../settings';

import './GraficoPerfil.scss';

class GraficoPerfil extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anoSelecionado: '2020',
      associadosDados: this.perfilAssociados2020,
      isMobile: '',
    };
  }
  perfilAssociados2020 = [
    {
      numero: 12,
      imagem: images.associados.build1,
      imagemMobile: images.associados.build1_mobile,
      descricao: 'Bancos comerciais',
    },
    {
      numero: 61,
      imagem: images.associados.build2,
      imagemMobile: images.associados.build2_mobile,
      descricao: 'Bancos múltiplos',
    },
    {
      numero: 6,
      imagem: images.associados.build_2020_6,
      imagemMobile: images.associados.build3_mobile,
      descricao: 'Bancos de investimento',
    },
    {
      numero: 31,
      imagem: images.associados.build4,
      imagemMobile: images.associados.build4_mobile,
      descricao: 'Corretoras',
    },
    {
      numero: 26,
      imagem: images.associados.build5,
      imagemMobile: images.associados.build5_mobile,
      descricao: 'Distribuidoras',
    },
    {
      numero: 125,
      imagem: images.associados.build6,
      imagemMobile: images.associados.build6_mobile,
      descricao: 'Gestoras',
    },
    {
      numero: 4,
      /*       imagem: images.associados.build4,
      imagemMobile: images.associados.build4_mobile, */
      imagem: images.associados.build_2020_4,
      imagemMobile: images.associados.build3_mobile,
      descricao: 'Securitizadoras',
    },
    {
      numero: 5,
      imagem: images.associados.build_2020_5,
      imagemMobile: images.associados.build7_mobile,
      descricao: 'Demais instituições',
    },
  ];
  perfilAssociados2019 = [
    {
      numero: 11,
      imagem: images.associados.build1,
      imagemMobile: images.associados.build1_mobile,
      descricao: 'Bancos comerciais',
    },
    {
      numero: 61,
      imagem: images.associados.build2,
      imagemMobile: images.associados.build2_mobile,
      descricao: 'Bancos múltiplos',
    },
    {
      numero: 7,
      imagem: images.associados.build3,
      imagemMobile: images.associados.build3_mobile,
      descricao: 'Bancos de investimento',
    },
    {
      numero: 33,
      imagem: images.associados.build4,
      imagemMobile: images.associados.build4_mobile,
      descricao: 'Corretoras',
    },
    {
      numero: 30,
      imagem: images.associados.build5,
      imagemMobile: images.associados.build5_mobile,
      descricao: 'Distribuidoras',
    },
    {
      numero: 113,
      imagem: images.associados.build6,
      imagemMobile: images.associados.build6_mobile,
      descricao: 'Gestoras',
    },
    {
      numero: 10,
      imagem: images.associados.build7,
      imagemMobile: images.associados.build7_mobile,
      descricao: 'Demais instituições',
    },
  ];
  perfilAssociados2018 = [
    {
      numero: 11,
      imagem: images.associados.build1,
      imagemMobile: images.associados.build1_mobile,
      descricao: 'Bancos comerciais',
    },
    {
      numero: 60,
      imagem: images.associados.build2,
      imagemMobile: images.associados.build2_mobile,
      descricao: 'Bancos múltiplos',
    },
    {
      numero: 7,
      imagem: images.associados.build3,
      imagemMobile: images.associados.build3_mobile,
      descricao: 'Bancos de investimento',
    },
    {
      numero: 34,
      imagem: images.associados.build4,
      imagemMobile: images.associados.build4_mobile,
      descricao: 'Corretoras',
    },
    {
      numero: 30,
      imagem: images.associados.build5,
      imagemMobile: images.associados.build5_mobile,
      descricao: 'Distribuidoras',
    },
    {
      numero: 108,
      imagem: images.associados.build6,
      imagemMobile: images.associados.build6_mobile,
      descricao: 'Gestoras',
    },
    {
      numero: 10,
      imagem: images.associados.build7,
      imagemMobile: images.associados.build7_mobile,
      descricao: 'Demais instituições',
    },
  ];
  perfilAssociados2017 = [
    {
      numero: 13,
      imagem: images.associados.build1,
      imagemMobile: images.associados.build1_mobile,
      descricao: 'Bancos comerciais',
    },
    {
      numero: 59,
      imagem: images.associados.build2,
      imagemMobile: images.associados.build2_mobile,
      descricao: 'Bancos múltiplos',
    },
    {
      numero: 7,
      imagem: images.associados.build3,
      imagemMobile: images.associados.build3_mobile,
      descricao: 'Bancos de investimento',
    },
    {
      numero: 34,
      imagem: images.associados.build4,
      imagemMobile: images.associados.build4_mobile,
      descricao: 'Corretoras',
    },
    {
      numero: 31,
      imagem: images.associados.build5,
      imagemMobile: images.associados.build5_mobile,
      descricao: 'Distribuidoras',
    },
    {
      numero: 111,
      imagem: images.associados.build6,
      imagemMobile: images.associados.build6_mobile,
      descricao: 'Gestoras',
    },
    {
      numero: 12,
      imagem: images.associados.build7,
      imagemMobile: images.associados.build7_mobile,
      descricao: 'Demais instituições',
    },
  ];

  anoSelecionado = e => {
    switch (e) {
      case '2020':
        this.setState({
          associadosDados: this.perfilAssociados2020,
        });

        $('.swiper-button-next').css('display', 'block');

        break;
      case '2019':
        this.setState({
          associadosDados: this.perfilAssociados2019,
        });

        let swiperLangth = $('.swiper-slide').length;
        let p2019 = this.perfilAssociados2019.length;

        if (swiperLangth === 8) {
          $('.swiper-button-prev').trigger('click');
        }

        let click = 0;
        p2019 = p2019 - 1;

        $('.swiper-button-next').on('click', function() {
          click = click + 1;
          if (click === p2019) {
            $('.swiper-button-next').css('display', 'none');
          }
        });

        $('.swiper-button-prev').on('click', function() {
          $('.swiper-button-next').css('display', 'block');
          click = click - 1;
        });

        break;
      case '2018':
        this.setState({
          associadosDados: this.perfilAssociados2018,
        });

        let swiperLangth2018 = $('.swiper-slide').length;
        let p2018 = this.perfilAssociados2018.length;

        if (swiperLangth2018 === 8) {
          $('.swiper-button-prev').trigger('click');
          $('.swiper-button-next').css('display', 'none');
        }

        let click2018 = 0;
        p2018 = p2018 - 1;

        $('.swiper-button-next').on('click', function() {
          click2018 = click2018 + 1;
          if (click2018 === p2018) {
            $('.swiper-button-next').css('display', 'none');
          }
        });

        $('.swiper-button-prev').on('click', function() {
          $('.swiper-button-next').css('display', 'block');
          click2018 = click2018 - 1;
        });

        break;
      case '2017':
        this.setState({
          associadosDados: this.perfilAssociados2017,
        });

        let swiperLangth2017 = $('.swiper-slide').length;
        let p2017 = this.perfilAssociados2017.length;

        if (swiperLangth2017 === 8) {
          $('.swiper-button-prev').trigger('click');
          $('.swiper-button-next').css('display', 'none');
        }

        let click2017 = 0;
        p2017 = p2017 - 1;

        $('.swiper-button-next').on('click', function() {
          click2017 = click2017 + 1;
          if (click2017 === p2017) {
            $('.swiper-button-next').css('display', 'none');
          }
        });

        $('.swiper-button-prev').on('click', function() {
          $('.swiper-button-next').css('display', 'block');
          click2017 = click2017 - 1;
        });

        break;
      default:
        associadosDados = this.perfilAssociados2020;
        break;
    }

    this.setState({
      perfilDados: this.perfilRecarrega,
    });
  };
  params = {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };
  render() {
    if (window.innerWidth < 768) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    return (
      <div className="associados-perfil">
        <div className="associados-perfil__conteudo">
          <div className="row associados-perfil__container-titulo">
            <Fade left big>
              <h3 className="associados-perfil__titulo">
                Perfil do <br />
                associado
              </h3>
            </Fade>
            <h4 className="associados-perfil__subtitulo">
              Veja o segmento em que <br /> os associados atuam:
            </h4>
            <div className="associados-perfil__container-select">
              <Select selecionaAno={this.anoSelecionado.bind(this)} estilo="escuro" />
            </div>
          </div>
          {!this.state.isMobile && (
            <div className="perfil-grafico">
              <div className="perfil-grafico__conteudo">
                <Fade bottom>
                  {/* <div className="perfil-grafico__arvore-esq">
                    <img src={images.associados.arvoresEsq} alt="Árvores" />
                  </div> */}
                  {this.state.associadosDados.map((res, i) => {
                    return (
                      <div className="perfil-grafico__item" key={i}>
                        <div className="perfil-grafico__risca-container">
                          <span className="perfil-grafico__numero">
                            <CountUp start={0} end={res.numero} delay={0} decimals={0} />
                          </span>
                          <div className="perfil-grafico__risca"></div>
                        </div>
                        <img src={res.imagem} alt="Prédio Gráfico" />
                        <span className="perfil-grafico__descricao">{res.descricao}</span>
                      </div>
                    );
                  })}
                  {/* <div className="perfil-grafico__arvore-dir">
                    <img src={images.associados.arvoresDir} alt="Árvores" />
                  </div> */}
                </Fade>
                <span className="linha"></span>
              </div>
            </div>
          )}
          {this.state.isMobile && (
            <Swiper {...this.params}>
              {this.state.associadosDados.map((res, i) => {
                return (
                  <div className="perfil-grafico__item" key={i}>
                    <div className="perfil-grafico__risca-container">
                      <span className="perfil-grafico__numero">
                        <CountUp start={0} end={res.numero} delay={0} decimals={0} />
                      </span>
                      <div className="perfil-grafico__risca"></div>
                    </div>
                    <img src={res.imagemMobile} alt="Prédio Gráfico" />
                    <span className="perfil-grafico__descricao">{res.descricao}</span>
                  </div>
                );
              })}
            </Swiper>
          )}
        </div>
      </div>
    );
  }
}

export { GraficoPerfil };
